export default "Récupération chaleur fatale — Fiche CEE IND-UT-131 | Solution Éco France";
